










import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SessionDateTime extends Vue {
  private months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  @Prop() day!: string;

  @Prop() timeStart!: string;

  @Prop() timeEnd!: string | undefined;

  private get prettyDate(): string {
    const date = new Date(this.day);
    const month = this.months[date.getMonth()];
    return `${date.getDate()} ${month}`;
  }

  private get prettyTime(): string {
    return `
      ${this.timeStart.slice(0, 5)}
      ${this.timeEnd !== undefined ? ` - ${this.timeEnd.slice(0, 5)}` : ''}
    `;
  }
}
